import { render, staticRenderFns } from "./FolderMediaFloatBtns.vue?vue&type=template&id=61a06113&"
import script from "./FolderMediaFloatBtns.vue?vue&type=script&lang=js&"
export * from "./FolderMediaFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports